import {
  ACTION_LOAD_AFFILIATE_PROGRAMS__REQUEST,
  ACTION_LOAD_AFFILIATE_PROGRAMS__SUCCESS,
  ACTION_LOAD_AFFILIATE_PROGRAMS__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_AFFILIATE_PROGRAMS__REQUEST:
    case ACTION_LOAD_AFFILIATE_PROGRAMS__SUCCESS:
      return null;

    case ACTION_LOAD_AFFILIATE_PROGRAMS__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
